import { Grid } from '@mui/material';
import { useSeatBet } from '../../../../../../hooks/useSeatBet';
import { BetRoomSeatIndex } from '../../../../../../models/games/BetRoom';
import { BlackjackDecision } from '../../../../../../models/games/blackjack';

type DecisionSymbolsProps = {
    sn: BetRoomSeatIndex;
};
export const DecisionSymbols = ({ sn }: DecisionSymbolsProps) => {
    const { decision, boughtInsurance } = useSeatBet(sn);
    return decision ? (
        <Grid container>
            <Grid item xs={4}>
                {boughtInsurance && <InsuranceSymbol />}
            </Grid>
            <Grid item xs={4}>
                {decision === BlackjackDecision.Split && <SplittedSymbol />}
            </Grid>
            <Grid item xs={4}>
                {decision === BlackjackDecision.Surrender && (
                    <SurrenderSymbol />
                )}
            </Grid>
        </Grid>
    ) : (
        <></>
    );
};

const InsuranceSymbol = () => (
    <svg
        width="20.71"
        height="20"
        viewBox="0 0 29 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M28.5 13.981C28.5161 21.6931 22.2584 27.9775 14.54 27.9999C6.8118 28.023 0.514419 21.7576 0.500025 14.0328C0.48563 6.29823 6.74098 0.0167287 14.4744 3.33133e-05C22.2032 -0.0166621 28.4838 6.24411 28.5 13.981ZM22.6903 13.9948C22.6868 9.47956 19.0237 5.81579 14.5066 5.80888C9.98554 5.80197 6.30165 9.4882 6.30914 14.0103C6.3172 18.5371 9.96596 22.1842 14.4928 22.1905C19.0265 22.1968 22.6937 18.5302 22.6897 13.9948H22.6903ZM21.4126 20.8842C20.485 21.8313 19.4273 22.5066 18.2464 23.0247C18.5861 23.852 18.9148 24.6534 19.2482 25.4657C20.7919 24.8336 22.1231 23.9441 23.2367 22.7985C22.6246 22.156 22.0316 21.5336 21.4126 20.8842ZM9.75407 2.53658C8.21442 3.17446 6.87053 4.06565 5.75581 5.17964C6.3742 5.82442 6.97475 6.45021 7.58623 7.08867C8.50461 6.1756 9.57155 5.49455 10.7536 4.97469C10.4133 4.14452 10.0869 3.34832 9.75407 2.53658ZM3.03521 18.7472C3.65937 20.2821 4.54666 21.6142 5.72817 22.7904C6.34484 22.1439 6.94366 21.5169 7.55284 20.8785C6.67764 19.9971 5.9867 18.9476 5.4777 17.7467C4.65663 18.0829 3.85398 18.4116 3.03579 18.7467L3.03521 18.7472ZM3.03464 9.25331C2.38861 10.7847 2.09208 12.3466 2.09611 13.9827H4.743C4.7476 12.692 4.99289 11.4617 5.47655 10.2568C4.66124 9.9217 3.86723 9.59586 3.03464 9.25331ZM9.75638 25.4657C11.2891 26.1018 12.853 26.4144 14.4847 26.4012V23.7576C13.1904 23.7541 11.9536 23.5002 10.7548 23.0247C10.4151 23.8543 10.0903 24.6488 9.75638 25.4657ZM19.2459 2.53313C17.7068 1.9154 16.1505 1.59013 14.5204 1.59819V4.19633C15.1688 4.27693 15.8004 4.32126 16.4171 4.44274C17.0314 4.56363 17.6308 4.76225 18.2619 4.93323C18.5797 4.15776 18.9051 3.36444 19.2459 2.53313ZM25.9705 18.734C26.5135 17.7841 27.0904 14.8232 26.8987 14.023H24.2898C24.28 15.3189 24.0284 16.548 23.5563 17.7449C24.3831 18.084 25.1777 18.4093 25.9705 18.734ZM21.4863 7.13012C22.3235 7.96892 23.0139 9.02879 23.5263 10.2257C24.3572 9.88428 25.1587 9.55556 25.959 9.22625C25.4063 7.81233 24.1165 5.90272 23.2355 5.209C22.6603 5.84054 22.0799 6.47785 21.4863 7.12954V7.13012ZM18.8705 18.3794H16.9767L16.219 15.9902H12.7556L12.0405 18.3794H10.1836L13.5525 7.8296H15.4025L18.8705 18.3794ZM15.6565 14.2055L14.4617 10.2907L13.2894 14.2055H15.6559H15.6565Z"
            fill="white"
        />
    </svg>
);

const SplittedSymbol = () => (
    <svg
        width="23.57"
        height="20"
        viewBox="0 0 33 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M26.0192 27.9423L14.8845 24.622C14.1817 24.3918 13.7708 23.5437 13.9669 22.7272L18.7887 2.4325C19.023 1.37844 19.8821 1.21628 20.7412 1.54061L31.5338 5.29548C32.2367 5.52575 32.6475 6.37387 32.4515 7.19036L27.6468 26.881C27.4508 27.6975 26.7221 28.1726 26.0192 27.9423Z"
            fill="white"
        />
        <path
            d="M11.529 22.4965L15.9768 3.89158L15.6417 1.38293C15.5457 0.516165 14.8631 -0.0968095 14.118 0.0126503L1.6861 1.66914C0.941031 1.77941 0.41464 2.57077 0.511484 3.43753L3.49957 24.7652C3.59564 25.6319 4.27823 26.2449 5.0233 26.1354L12.228 25.1414C11.2127 24.4862 11.3158 23.3852 11.529 22.4965Z"
            fill="white"
        />
    </svg>
);
const SurrenderSymbol = () => (
    <svg
        width="17.86"
        height="20"
        viewBox="0 0 25 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M7.56237 15.1603C7.56237 15.1603 9.12604 16.9563 13.4293 16.1256C17.7325 15.2949 17.6166 12.9389 20.4166 12.0072C23.2175 11.0756 24.5006 12.2227 24.5006 12.2227L22.6203 0.265058C22.6203 0.265058 18.7253 -0.524003 16.0714 0.620736C13.4176 1.76547 14.5214 5.46084 11.0726 5.9527C7.62375 6.44456 5.86719 5.11958 5.86719 5.11958L7.56043 15.1603H7.56237Z"
            fill="white"
        />
        <path
            d="M5.86686 27.8821C6.71624 27.7645 7.30076 27.0495 7.17208 26.284L3.62856 5.40341C3.49988 4.63783 2.70802 4.11223 1.85865 4.22975C1.00927 4.34727 0.424775 5.06306 0.552561 5.82866L4.09695 26.7084C4.22563 27.474 5.01749 27.9996 5.86686 27.8821Z"
            fill="white"
        />
    </svg>
);
